import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Link, Typography } from '@mui/material';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import MyAvatar from '../../../components/MyAvatar';
import useAuth from '../../../hooks/useAuth';
// staff roles
import { staffRoleLabel } from '../../../constants/staffRoles';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1.25, 1.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.25,
  backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
  border: `1px solid ${theme.palette.divider}`,
  transition: theme.transitions.create(['background-color', 'transform'], {
    duration: theme.transitions.duration.shorter,
  }),
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  overflow: 'hidden',
}));

// ----------------------------------------------------------------------

type Props = {
  isCollapse: boolean | undefined;
};

export default function NavbarAccount({ isCollapse }: Props) {
  const { user } = useAuth();
  const profileLink = PATH_DASHBOARD.overview;

  return (
    <Link underline="none" color="inherit" component={RouterLink} to={profileLink}>
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: 'transparent',
            border: 'none',
            px: 0.5,
          }),
        }}
      >
        <MyAvatar />

        <Box
          sx={{
            ml: 1.25,
            flexGrow: 1,
            minWidth: 0,
            transition: (theme) =>
              theme.transitions.create('width', {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0,
            }),
          }}
        >
          <Typography variant="body2" noWrap sx={{ color: 'text.primary', fontWeight: 600, fontSize: '0.8125rem' }}>
            {user?.displayName || 'Staff'}
          </Typography>
          <Typography variant="caption" noWrap sx={{ color: 'text.secondary', display: 'block', fontSize: '0.6875rem' }}>
            {user.roles.map(staffRoleLabel).join(', ') || 'No role yet'}
          </Typography>
        </Box>
      </RootStyle>
    </Link>
  );
}
